export default __webpack_public_path__ + "static/media/logoRestoCream.c84749a2.png";